import React from "react";
import { HomeHero } from "@/components/home/HomeHero";
import { HomeIntro, HomeGastronomy, HomeCoffee } from "@/components/home/HomeEditorial";
import { HomeOrigin } from "@/components/home/HomeOrigin";
import { HomeNaguara, HomeExperience } from "@/components/home/HomeNaguara";
import { HomeLocations, HomeReservation } from "@/components/home/HomeLocations";

export default function Home() {
  return <><HomeHero /><HomeIntro /><HomeGastronomy /><HomeCoffee /><HomeOrigin /><HomeNaguara /><HomeExperience /><HomeLocations /><HomeReservation /></>;
}